import { useSegmentAnalytics } from "./useSegmentAnalytics";

export const useKYCPageAnalytics = () => {
  const { trackButtonClickEvent, trackLinkClickEvent } = useSegmentAnalytics();

  const trackStartVerificationButtonEvent = () =>
    trackButtonClickEvent({
      label: "KYC screen 1 - Start verification button",
      location: "KYC screen 1 - Start verification button",
      extraProperties: {
        event_type: "Click",
        link_text: "Start verification button",
      },
    });

  const trackContinueOnPhoneButtonEmailEvent = () =>
    trackButtonClickEvent({
      label: "KYC screen 2 - Continue on phone button",
      location: "KYC screen 2 - Continue on phone button",
      extraProperties: {
        event_type: "Click",
        link_text: "Continue on phone button",
      },
    });

  const trackSendVerificationCodeButtonEmailEvent = () =>
    trackButtonClickEvent({
      label: "KYC screen 2 - Send verification code button",
      location: "KYC screen 2 - Send verification code button",
      extraProperties: {
        event_type: "Click",
        link_text: "Send verification code button",
      },
    });

  const trackSendVerificationCodeButtonPhoneEvent = () =>
    trackButtonClickEvent({
      label: "KYC screen 4 - Send verification code button",
      location: "KYC screen 4 - Send verification code button",
      extraProperties: {
        event_type: "Click",
        link_text: "Send verification code button",
      },
    });

  const trackContinueOnPhoneButtonPhoneEvent = () =>
    trackButtonClickEvent({
      label: "KYC screen 4 - Continue on phone button",
      location: "KYC screen 4 - Continue on phone button",
      extraProperties: {
        event_type: "Click",
        link_text: "Continue on phone button",
      },
    });

  const trackContinueOnPhoneButtonIDEvent = () =>
    trackButtonClickEvent({
      label: "KYC screen 7 - Continue on phone button",
      location: "KYC screen 7 - Continue on phone button",
      extraProperties: {
        event_type: "Click",
        link_text: "Continue on phone button",
      },
    });

  const trackContinueButtonIDEvent = () =>
    trackButtonClickEvent({
      label: "KYC screen 7 - Continue button",
      location: "KYC screen 7 - Continue button",
      extraProperties: {
        event_type: "Click",
        link_text: "Continue button",
      },
    });

  const trackContinueButtonProofOfResidenceEvent = () =>
    trackButtonClickEvent({
      label: "KYC screen 8 - Continue button",
      location: "KYC screen 8 - Continue button",
      extraProperties: {
        event_type: "Click",
        link_text: "Continue button",
      },
    });

  const trackContinueOnPhoneButtonProofOfResidenceEvent = () =>
    trackButtonClickEvent({
      label: "KYC screen 8 - Continue on phone button",
      location: "KYC screen 8 - Continue on phone button",
      extraProperties: {
        event_type: "Click",
        link_text: "Continue on phone button",
      },
    });

  const trackCompleteButtonEvent = () =>
    trackButtonClickEvent({
      label: "KYC final screen - Complete now button",
      location: "KYC final screen - Complete now button",
      extraProperties: {
        event_type: "Click",
        link_text: "Complete now button",
      },
    });

  const trackBackToDashboardButtonEvent = () =>
    trackButtonClickEvent({
      label: "KYC final screen - Back to dashboard button",
      location: "KYC final screen - Back to dashboard button",
      extraProperties: {
        event_type: "Click",
        link_text: "Back to dashboard button",
      },
    });

  // Back to Dashboard (Footer Link)
  const trackBackToDashboardLinkEvent = (
    event: React.MouseEvent<HTMLAnchorElement>,
  ) =>
    trackLinkClickEvent({
      event,
      label: "KYC ALL screens - Back to dashboard link",
      location: "KYC ALL screens - Back to dashboard link",
      extraProperties: {
        event_type: "Click",
        link_text: "Back to dashboard link",
      },
    });
  // Back to Dashboard (Mobile Close Button)
  const trackBackToDashboardButtonMobileEvent = () =>
    trackButtonClickEvent({
      label: "KYC ALL screens - Back to dashboard button",
      location: "KYC ALL screens - Back to dashboard button",
      extraProperties: {
        event_type: "Click",
        link_text: "Back to dashboard button",
      },
    });

  const trackChangeLanguageEvent = () =>
    trackButtonClickEvent({
      label: "KYC ALL screens - Change language button",
      location: "KYC ALL screens - Change language button",
      extraProperties: {
        event_type: "Click",
        link_text: "Change language button",
      },
    });

  return {
    trackBackToDashboardLinkEvent,
    trackBackToDashboardButtonMobileEvent,
    trackContinueOnPhoneButtonEmailEvent,
    trackContinueOnPhoneButtonPhoneEvent,
    trackStartVerificationButtonEvent,
    trackSendVerificationCodeButtonEmailEvent,
    trackSendVerificationCodeButtonPhoneEvent,
    trackContinueOnPhoneButtonIDEvent,
    trackContinueButtonIDEvent,
    trackContinueOnPhoneButtonProofOfResidenceEvent,
    trackContinueButtonProofOfResidenceEvent,
    trackCompleteButtonEvent,
    trackBackToDashboardButtonEvent,
    trackChangeLanguageEvent,
  };
};
